/**
 * Site readiness ("ready for JBS", #796) helpers shared by the Overview
 * panel, the JBS install dialog and the recovery dialogs.
 */

const DOCS_BASE = 'https://docs.jeket.com/jbs/install/readiness-checks';

/**
 * Each check id is a stable reason code, and the install docs (#839) have a
 * section per id anchored by the id itself.
 */
export function readinessDocsUrl(checkId: string): string {
  return `${DOCS_BASE}#${encodeURIComponent(checkId)}`;
}

export const siteReadinessQueryKey = (siteId: string) => ['site-readiness', siteId] as const;
